import { sendEvent, sendException } from 'helpers/analytics';
import {
  getChannelContextAdditionalInfo,
  getChannelContextCode,
  getJsonStringify
} from 'helpers/Utility';
import { setError } from 'store/actions/auth';
import { loading } from 'store/actions/loanApply';

export const handleAuthError = (err, dispatch, phoneNo, history) => {
  const incorrectPinErrCodes = ['4000203', '4000202', '4030101'];
  const needResetErrCodes = ['106803', '24036', '4000008', '4000005'];

  if (err.toString().includes('Network Error')) {
    return dispatch(setError('connection'));
  }

  if (
    needResetErrCodes.includes(getChannelContextCode(err, 'channel-context'))
  ) {
    return dispatch(setError('need_reset_pin'));
  }

  if (
    incorrectPinErrCodes.includes(getChannelContextCode(err, 'channel-context'))
  ) {
    dispatch(setError('incorrect_pin'));
    dispatch(loading(false));
    return;
  } else if (getChannelContextCode(err, 'channel-context') === '400502') {
    const addInfo = getChannelContextAdditionalInfo(err, 'channel-context');
    const freezeTime = addInfo?.freezeEnd;
    localStorage.setItem('pinFreeze', JSON.stringify({ freezeTime }));
    dispatch(setError('temporary_locked'));
    dispatch(loading(false));
    return;
  } else if (getChannelContextCode(err, 'channel-context') === '4000007') {
    dispatch(setError('have-change-number'));
    dispatch(loading(false));
    return;
  } else {
    localStorage.removeItem('phoneNo', '');
    localStorage.removeItem('phonePrincipal', '');
    dispatch(setError('system'));
  }

  if (
    getChannelContextCode(err, 'channel-context') === '24037' ||
    getChannelContextCode(err, 'channel-context') === '4030001'
  ) {
    history &&
      history.push({
        pathname: '/account-deleted',
        state: {
          phoneDeleted: phoneNo
        }
      });
    return;
  }

  if (
    (err.response && err.response.status === 401) ||
    getChannelContextCode(err, 'channel-context') === '24032'
  ) {
    return dispatch(setError('incorrect_pin'));
  }

  // fallback
  dispatch(setError('system'));
  sendEvent({
    category: 'Unexpected Error Login',
    action: getJsonStringify(err.response),
    label: phoneNo
  });
  sendException({
    desc: getJsonStringify(err.response),
    fatal: true
  });
};
